module.exports = __webpack_public_path__ + "static/couple-hugging-mobile.877329d6.webp";